import { SerializedStyles } from '@emotion/react';
import * as React from 'react';

import loader from '../../../assets/img/new-loader.gif';

interface Props {
  width: string | number;
  height: string | number;
  customCss?: SerializedStyles;
  alt?: string;
}

const Loader = ({ width, height, customCss, alt = 'loading' }: Props) => (
  <img css={customCss} src={loader} style={{ height, width }} alt={alt} data-testid="loader-img" />
);

export default Loader;
